<template>
  <div class="min-h-screen">
    <div v-if="!showTeamMember" class="bg-white rounded-md m-3">
      <div class="flex gap-4 bg-white pt-3 mb-2 mx-3 lg:w-1/2">
        <input
          type="date"
          placeholder="Pick a date"
          class="rounded-xl w-1/2 pl-4 py-1 bg-gray-200"
        />
        <input
          type="text"
          placeholder="Search employee"
          class="rounded-xl w-1/2 pl-4 py-1 bg-gray-200"
        />
        <select class="rounded-xl w-1/2 pl-4 py-1 bg-gray-200">
          <option>Department</option>
        </select>
      </div>
      <div class="p-3">
        <!-- <ve-table :columns="columns" :table-data="tableData" /> -->

        <div
          v-if="!loading && tableData.length === 0"
          class="flex flex-col justify-center items-center h-full mt-5"
        >
          <el-empty :image-size="70" description="No Data"></el-empty>
        </div>
      </div>
    </div>
    <team-member
      v-if="showTeamMember"
      @backToTeam="showTeamMember = false"
    ></team-member>
  </div>
</template>

<script>
import teamMember from "./teamMember.vue";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "team",
  components: {
    teamMember,
  },
  data() {
    return {
      showTeamMember: false,
      columns: [
        {
          field: "Name",
          key: "aa",
          title: "Employee Name",
          align: "left",
          width: "15%",
          renderBodyCell: ({ row }) => {
            return (
              <div
                on-click={() => this.viewEmployee()}
                class="flex gap-5 items-center"
              >
                <div class="h-8 w-8 rounded-full">
                  <img
                    class="h-full w-full rounded-full"
                    src="https://cdn2.iconfinder.com/data/icons/flatfaces-everyday-people-square/128/african_flatcut_boy_man_black_face_avatar-512.png"
                  />
                </div>
                <p class="text-blue-500 cursor-pointer">{row.Fullname}</p>
              </div>
            );
          },
        },
        {
          field: "Date",
          key: "a",
          title: "Date In",
          renderBodyCell: ({ row }) => {
            const dateStr = row.ClockInTime;
            const dateObj = new Date(dateStr);
            const month = dateObj.toLocaleString("default", { month: "long" });
            const day = dateObj.getDate();
            const year = dateObj.getFullYear();

            const formattedDate = `${month}, ${day}, ${year}`;
            return formattedDate;
          },
        },
        {
          field: "ClockInTime",
          key: "b",
          title: "Clock In",
          renderBodyCell: ({ row }) => {
            const dateTimeString = row.ClockInTime;
            const date = new Date(dateTimeString);
            return date.toLocaleString("en-US", {
              hour: "numeric",
              minute: "numeric",
              hour12: true,
            });
          },
        },
        {
          field: "ClockInLocation",
          key: "c",
          title: "Clock In Location",
        },
        {
          field: "Date",
          key: "aaa",
          title: "Date Out",
          renderBodyCell: ({ row }) => {
            if (row.ClockOutTime) {
              const dateStr = row.ClockOutTime;
              const dateObj = new Date(dateStr);
              const month = dateObj.toLocaleString("default", {
                month: "long",
              });
              const day = dateObj.getDate();
              const year = dateObj.getFullYear();

              const formattedDate = `${month}, ${day}, ${year}`;
              return formattedDate;
            } else {
              return "";
            }
          },
        },
        {
          field: "ClockOutTime",
          key: "bb",
          title: "Clock Out",
          renderBodyCell: ({ row }) => {
            if (row.ClockOutTime) {
              const dateTimeString = row.ClockOutTime;

              const date = new Date(dateTimeString);
              return date.toLocaleString("en-US", {
                hour: "numeric",
                minute: "numeric",
                hour12: true,
              });
            } else {
              return "";
            }
          },
        },
        {
          field: "ClockOutLocation",
          key: "x",
          title: "Clock Out Location",
        },

        {
          field: "WorkSchedule",
          key: "d",
          title: "Work Schedule",
          renderBodyCell: ({ row }) => {
            // //console.log(row);
            return <p class="">{row.WorkSchedule} hrs</p>;
          },
        },

        {
          field: "LoggedIn",
          key: "f",
          title: "Logged In",
          renderBodyCell: ({ row }) => {
            if (row.ClockOutTime) {
              const date1 = new Date(row.ClockInTime);
              const date2 = new Date(row.ClockOutTime); // current date and time
              const diffInMs = date2.getTime() - date1.getTime();

              const totalSeconds = Math.floor(diffInMs / 1000);
              const hours = Math.floor(totalSeconds / 3600);

              return `${hours} hrs`;
            } else {
              return "......";
            }
          },
        },
        {
          field: "Overtime",
          key: "g",
          title: "Overtime",

          renderBodyCell: ({ row }) => {
            if (row.Overtime) {
              return (
                <p class="" style="color: green">
                  {parseFloat(row.Overtime.toFixed(1))} hrs
                </p>
              );
            } else {
              return "......";
            }
          },
        },
        {
          field: "Deficit",
          key: "h",
          title: "Deficit",
          renderBodyCell: ({ row }) => {
            if (row.Deficit) {
              return (
                <p class="" style="color: #E85656">
                  {parseFloat(row.Deficit.toFixed(1))} hrs
                </p>
              );
            } else {
              return "......";
            }
          },
        },
        {
          field: "Action",
          key: "ff",
          title: "Action",
          renderBodyCell: () => {
            return (
              <p class="cursor-pointer transform rotate-90 font-bold">
                &#8230;
              </p>
            );
          },
        },
      ],
      tableData: [],
    };
  },
  created() {
    this.getTeamAttendance();
  },
  computed: {
    ...mapGetters([
      "getClockInTime",
      "isUseClockedIn",
      "getOrganization",
      "getToken",
    ]),
  },
  methods: {
    viewEmployee() {
      this.showTeamMember = true;
    },
    getTeamAttendance() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/attendance/me/${this.$ApiVersion}/request`,
          options
        )
        .then(
          async (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.tableData = response.data.Data;
              //console.log(this.tableData);

              this.tableData = await Promise.all(
                this.tableData.map(async (row) => {
                  const clockIn = await this.fetchClockInLocations(row);
                  const clockOut = await this.fetchClockOutLocations(row);

                  return {
                    ...row,
                    ClockOutLocation: clockOut,
                    ClockInLocation: clockIn,
                  };
                })
              );

              //console.log(this.tableData);
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          () => {
            this.loading = false;
          }
        );
    },

    async getLocationName(lng, lat) {
      if (lng && lat) {
        const apiKey =
          "pk.eyJ1IjoiaGVybWl0ZXgiLCJhIjoiY2xldHNyc2JoMWFidjNycDExaWt1YXlzNyJ9.TVgjvCPzeZQbPHBXcDvcTg";
        try {
          const response = await axios.get(
            `https://api.mapbox.com/geocoding/v5/mapbox.places/${lat},${lng}.json?access_token=${apiKey}`
          );
          const location = response.data.features[0].place_name;
          const formattedLocation = location.substring(4).trim();
          return formattedLocation;
        } catch (err) {
          //console.log(err);
          return "";
        }
      } else return "";
    },
    async fetchClockInLocations(row) {
      return (this.clockInLocation = await this.getLocationName(
        row.ClockInLatitude,
        row.ClockInLongitude
      ));
    },
    async fetchClockOutLocations(row) {
      return (this.clockOutLocation = await this.getLocationName(
        row.ClockOutLatitude,
        row.ClockOutLongitude
      ));
    },
  },
};
</script>
